import { useState } from "react";
import { Play } from "lucide-react";
import { animations } from "@/data/content";
import { Reveal, SectionLabel, youtubeId } from "./Reveal";

const VideoCard = ({ a, i }) => {
  const [playing, setPlaying] = useState(false);
  const id = youtubeId(a.youtube);
  const poster = a.poster || (id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : "");

  return (
    <Reveal delay={(i % 2) * 0.1} data-testid={`animation-card-${i}`}>
      <div className="group relative aspect-video overflow-hidden rounded-[24px] bg-[#05325F]">
        {playing && id ? (
          <iframe src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`} title={a.title}
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen
            className="absolute inset-0 h-full w-full" data-testid={`animation-iframe-${i}`} />
        ) : (
          <button onClick={() => id && setPlaying(true)} disabled={!id} aria-label={id ? `Play ${a.title}` : "Video not linked yet"}
            className="absolute inset-0 h-full w-full disabled:cursor-default" data-testid={`animation-play-${i}`}>
            {poster && <img src={poster} alt="" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />}
            <span className="absolute inset-0 bg-[#05325F]/35 transition-colors duration-500 group-hover:bg-[#05325F]/15" />
            <span className="absolute inset-0 flex flex-col items-center justify-center gap-3">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white text-[#05325F] shadow-xl transition-transform duration-500 group-hover:scale-110">
                <Play className="ml-1 h-6 w-6 fill-current" />
              </span>
              {!id && <span className="rounded-full bg-white/90 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.15em] text-[#05325F]">Add YouTube link</span>}
            </span>
            <span className="absolute right-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[11px] font-bold tracking-widest text-[#05325F]">{a.duration}</span>
          </button>
        )}
      </div>
      <div className="mt-5 flex items-start gap-5">
        <span className="pt-1 text-sm font-bold tracking-widest text-[#09549F]">0{i + 1}</span>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#4A607A]">{a.subject}</p>
          <h3 className="mt-1 text-2xl font-bold leading-tight text-[#05325F]">{a.title}</h3>
          <p className="mt-2 max-w-lg text-sm leading-relaxed text-[#4A607A]">{a.summary}</p>
        </div>
      </div>
    </Reveal>
  );
};

export const Animations = () => (
  <section id="animations" className="bg-white py-24 md:py-32" data-testid="animations-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-14 max-w-3xl">
        <SectionLabel index="02">Animations</SectionLabel>
        <h2 className="text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-[#05325F] sm:text-5xl lg:text-6xl">Selected animations</h2>
      </Reveal>
      <div className="grid gap-x-8 gap-y-14 md:grid-cols-2">
        {animations.map((a, i) => <VideoCard key={a.id} a={a} i={i} />)}
      </div>
    </div>
  </section>
);
